const MethodInvokeNode = ({data} : any) => {
    return (<div>Method Invoke Node</div>);
};

export default MethodInvokeNode;
